import type { Item } from '../core/hp/types';

export type PlanSurface = 'floor' | 'ceiling';

export function isPlanItemVisible(item: Item, surface: PlanSurface, ceilingHeight = 2.7): boolean {
  return surface === 'floor' ? item.placement !== 'ceiling'
    : item.placement === 'ceiling' || item.elevation + item.size.h >= ceilingHeight - 0.2;
}
